// extracted by mini-css-extract-plugin
export default {"popper":"bdBYcXaZVxwclwYJs2Wz"};